import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { slot: "content" }

import { ref, defineComponent, computed, watch, reactive, } from 'vue';

// icons
import { add, close, arrowBack, checkmarkCircle, alertCircle, ellipsisHorizontal, ellipsisVertical, pencil, chevronDown, } from 'ionicons/icons';

// components
import { IonItem, IonLabel, IonIcon, IonButtons, IonButton, IonAccordion, IonAccordionGroup, IonList, IonCard, } from '@ionic/vue';

// composables / services
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionAccordionGroup',
  props: {
  value: String,
  noPadding: Boolean,
  noAccordion: Boolean,
  headerColor: String,
  noHeader: Boolean,
  expandAll: Boolean,
},
  setup(__props) {

// Vue reactivity
const props = __props;

const { t } = useI18n();
const { openModal, } = utils();

return (_ctx: any,_cache: any) => {
  return (__props.expandAll)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!__props.noHeader)
          ? (_openBlock(), _createBlock(_unref(IonItem), {
              key: 0,
              lines: "none",
              color: __props.headerColor || 'fdmtred'
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), {
                  class: _normalizeClass({'ion-padding-start': !__props.noPadding})
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "header")
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            }, 8, ["color"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({'ion-padding-start': !__props.noPadding})
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ]))
    : (_openBlock(), _createBlock(_unref(IonAccordionGroup), {
        key: 1,
        value: __props.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonAccordion), {
            style: {"--min-height":"24px"},
            value: __props.value,
            "toggle-icon": __props.noAccordion ? null : _unref(chevronDown),
            readonly: !!__props.noAccordion
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                lines: "none",
                slot: "header",
                color: __props.headerColor || 'fdmtred'
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), {
                    class: _normalizeClass({'ion-padding-start': !__props.noPadding})
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "header")
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              }, 8, ["color"]),
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]),
            _: 3
          }, 8, ["value", "toggle-icon", "readonly"])
        ]),
        _: 3
      }, 8, ["value"]))
}
}

})